import { axiosObject } from "../config";

function getBanks() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    let payload = {
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllBanks() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    let payload = {
      limitBy: {
        per_page: 1000,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        {
          attribute: "deleted_at",
          op: "is",
          value: null,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBank(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/banks/_read";
    let payload = {
      filterBy: [
        {
          attribute: "slug",
          op: "in",
          value: data.slug,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getBankBranchByBankUuid(uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/bank-branches/_read";
    let payload = {
      filterBy: [{ attribute: "bank_uuid", op: "eq", value: uuid }],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getBanks, getBank, getAllBanks, getBankBranchByBankUuid };
